import { v4 } from "uuid";
import { SurveyAnswerType, SurveyQuestionType } from "features/Library/Surveys/types/models";
import { type SurveyAnswer } from "features/Library/Surveys/SurveyDetails/SurveyContentForm/types";

const defaultAnswerData = ((): { [key in SurveyAnswerType]: () => SurveyAnswer } => {
  const stringAnswer = (): SurveyAnswer => {
    const id = v4();
    return {
      answer: "",
      answerType: SurveyAnswerType.Text,
      answerOrder: undefined,
      id,
      bulletId: id,
    };
  };

  return {
    [SurveyAnswerType.Text]: stringAnswer,
  };
})();

export const getAnswerDefaultData = (questionType: number): SurveyAnswer => {
  const questionTypeToAnswerType = {
    [SurveyQuestionType.SingleChoiceTextQuestion]: SurveyAnswerType.Text,
    [SurveyQuestionType.MultipleChoiceTextQuestion]: SurveyAnswerType.Text,
    [SurveyQuestionType.FreeText]: SurveyAnswerType.Text,
    [SurveyQuestionType.RatingScale]: SurveyAnswerType.Text,
  };
  return defaultAnswerData[questionTypeToAnswerType[questionType as SurveyQuestionType]]();
};
